<template>
  <v-layout
    d-block
    d-md-flex
    row
    ma-0
    align-center
    justify-space-between
    class="instruction"
  >
    <v-flex xs12 md6>
      <template v-if="survey.info.status !== 'sent'">
        <h4 v-html="survey.info[`title_${$i18n.locale}`]"></h4>
      </template>
      <template v-else-if="survey.info.status === 'sent'">
        <h4>{{ $t("edit-audit-screen.survey-header.titlefinal") }}</h4>
      </template>
      <!-- <pre>{{survey}}</pre> -->
      <ProgressBar
        :progress="parseInt(survey.done.point)"
        :objectif="parseInt(survey.total.point)"
        :minimum="parseInt(survey.total.requiredpt)"
        :donemandatoryq="parseInt(survey.done.mandatoryq)"
        :mandatoryq="parseInt(survey.total.mandatoryq)"
      ></ProgressBar>
    </v-flex>
    <v-divider vertical></v-divider>
    <v-flex xs12 md5>
      <template v-if="survey.info.status !== 'sent'">
        <small>{{ $tc("edit-audit-screen.survey-header.score-1", 1,
                    {percent: survey && percentProgressAudit !== NaN && percentProgressAudit !== 'NaN' ? Math.round(percentProgressAudit) : '0'}) }}</small><br>
        <small>{{  $tc("edit-audit-screen.survey-header.score-2", 1,
                      {score: survey ? survey.total.requiredpt : '0'}) }}</small><br>
        <small>{{ $tc("edit-audit-screen.survey-header.score-3", 1,
                    {mandatoryq: survey ? survey.done.mandatoryq : '0',
                      rmandatoryq: survey ? survey.total.mandatoryq : '0'}) }}</small>
      </template>
      <template v-else-if="survey.info.status === 'sent'">
        <!-- <small>{{ $t("edit-audit-screen.survey-header.scorefinal-1") }}</small><br> -->
        <small>{{  $tc("edit-audit-screen.survey-header.scorefinal-2", 1,
                      {score: survey ? survey.done.point : '0',
                       minscore: survey ? survey.total.requiredpt : '0'}) }}</small><br>
        <small>{{ $t("edit-audit-screen.survey-header.scorefinal-3") }}</small>
      </template>
    </v-flex>
  </v-layout>
</template>

<script>
import ProgressBar from '@/components/progress/ProgressBar'
export default {
  props: {
    survey: Object
  },

  components: {
    ProgressBar: ProgressBar
  },

  computed: {
    percentProgressAudit () {
      let percentProgress
      if (parseInt(this.survey.total.point) > 0) {
        percentProgress = (parseInt(this.survey.done.point) / parseInt(this.survey.total.point)) * 100
      } else {
        percentProgress = 0
      }
      return percentProgress
    }
  }
}
</script>
